import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PITEventService, UtilsMisc } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFacade } from '@pit/core-store';
import { IDtoShipment } from '@pit/frontend-model';
import { DtoShipmentStoreFactory } from './dto.shipment.store.factory';
import { IDtoShipmentEntityDataService } from '../../module.data/services/interfaces/dto.shipment.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoShipmentStoreFacade extends EntityStoreFacade<IDtoShipment> {

    constructor(store: Store<IDtoShipment>, dataServiceAccessor: EntityDataServiceAccessorService, eventService: PITEventService) {
        super(DtoShipmentStoreFactory.instance, store, 'DtoShipment', dataServiceAccessor, eventService);
    }

    public loadShipmentsByShipmentDate$(shipmentDate: Date): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.by.date')({ date: shipmentDate }));
    }

    public async loadShipmentsByShipmentDateAsync(shipmentDate: Date): Promise<IDtoShipment[]> {
        let result: IDtoShipment[] = null;
        try {
            const queryResult: IDtoShipment[] = await (this.dataServiceAccessor.getEntityDataService<IDtoShipment>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoShipmentEntityDataService).getShipmentsForDateAsync(shipmentDate);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
            this.eventService.useMethod('error.show', error);
        } finally {
        }

        return result;
    }

    public loadShipmentsActiveByUser$(userName: string): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.active.by.user')({ userName: userName }));
    }

    public async loadShipmentsActiveByUserAsync(userName: string): Promise<IDtoShipment[]> {
        let result: IDtoShipment[] = null;
        try {
            const queryResult: IDtoShipment[] = await (this.dataServiceAccessor.getEntityDataService<IDtoShipment>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoShipmentEntityDataService).getActiveShipmentsForUserAsync(userName);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
            this.eventService.useMethod('error.show', error);
        } finally {
        }

        return result;
    }

    public loadShipmentsActiveForDepot$(depotNumber: string): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.active.by.depot')({ depotNumber: depotNumber }));
    }

    public async loadShipmentsActiveForDepotAsync(depotNumber: string): Promise<IDtoShipment[]> {
        let result: IDtoShipment[] = null;
        try {
            const queryResult: IDtoShipment[] = await (this.dataServiceAccessor.getEntityDataService<IDtoShipment>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoShipmentEntityDataService).getActiveShipmentsForDepotAsync(depotNumber);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
            this.eventService.useMethod('error.show', error);
        } finally {
        }

        return result;
    }

    public loadShipmentsToReturnForDepot$(depotNumber: string, includeInDelivery: boolean = false): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.returns.by.depot')({ depotNumber: depotNumber, includeInDelivery: includeInDelivery }));
    }

    public async loadShipmentsToReturnForDepotAsync(depotNumber: string, includeInDelivery: boolean = false): Promise<IDtoShipment[]> {
        let result: IDtoShipment[] = null;
        try {
            const queryResult: IDtoShipment[] = await (this.dataServiceAccessor.getEntityDataService<IDtoShipment>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoShipmentEntityDataService).getShipmentsToReturnForDepotAsync(depotNumber, includeInDelivery);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
            this.eventService.useMethod('error.show', error);
        } finally {
        }

        return result;
    }

}
